export const contacts = {
  'CONTACTS': '联系方式',
  'Get in touch': '保持联系',
  '45 Rockefeller Plaza 1': '45洛克菲勒广场1',
  'Suite 2508': '2508号套房',
  'New York, New York 10111': '纽约，纽约10111',
}

export default contacts
